module.exports = __webpack_public_path__ + "img/other.72f40edf.jpg";